import React, { ReactNode, FC, useState, useEffect, useContext } from 'react';
import { Connect, PropsFromRedux } from './AddToFoldersFetcherContainer';
import { UserContext } from '../../user/UserContext';

type Props = {
  children: (props: { isLoading: boolean }) => ReactNode;
} & PropsFromRedux;

const RawAddToFoldersFetcher: FC<Props> = ({ onLoad, children }) => {
  const [isLoading, setLoading] = useState(true);
  const { accessPremium } = useContext(UserContext);

  useEffect(() => {
    async function loadData() {
      await onLoad();
      setLoading(false);
    }
    if (accessPremium) {
      loadData();
    }
  }, []);

  return <>{children({ isLoading })}</>;
};

export const AddToFoldersFetcher = Connect(RawAddToFoldersFetcher);
